import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { EmployeeForTableDTO } from './types'

export const EMPLOYEE_FOR_TABLE_FRAGMENT: TypedDocumentNode<EmployeeForTableDTO> = gql`
  fragment EmployeeForTableFragment on User {
    email
    firstName
    id
    lastName
    role
    status
    updatedAt
  }
`
